import { RJSFSchema, UiSchema } from '@rjsf/utils'
import validator from '@rjsf/validator-ajv8'
import { merge, pick } from 'lodash'

import Form, { extractUiSchema } from './components/Form'
import useDatasource from './hooks/useDatasource'

export function Metadata() {
  const [datasource, setDatasource] = useDatasource(true)

  const schema: RJSFSchema = {
    type: 'object',
    properties: {
      name: {
        type: 'string',
        title: 'Name'
      },
      version: {
        type: 'string',
        title: 'Version'
      },
      id: {
        type: 'string',
        title: 'Slug'
      },
      iconUrl: {
        type: 'string',
        title: 'Icon URL'
      },
      supportUrl: {
        type: 'string',
        title: 'Support URL'
      },
      vendorApiUrl: {
        type: 'string',
        title: 'Vendor API URL'
      }
    },
    required: ['name', 'version', 'id']
  }

  const uiSchema: UiSchema<any, typeof schema> = merge(extractUiSchema(schema), {
    'ui:options': {
      submitButtonOptions: {
        norender: true
      }
    },
    iconUrl: {
      'ui:widget': 'FileUpload'
    }
  })

  return (
    <Form
      className="flex flex-col gap-4 p-4"
      validator={validator}
      schema={schema}
      uiSchema={uiSchema}
      formData={pick(datasource, ['id', 'name', 'version', 'iconUrl', 'supportUrl', 'vendorApiUrl'])}
      onChange={event => setDatasource(datasource => ({ ...datasource, ...event.formData }))}
    />
  )
}
